<template>
	<div class="application--wrapper__outer compact-padding ">
		<div class="application--wrapper__inner container">
			<h1 class="heading--sm heading text-capitalize text-center">
				Apply for this job
			</h1>
			<p class="paragraph text-center">
				Don’t forget to include a resume and cover letter. We receive a
				lot of applications, but we’ll notice a fun, well-written intro
				that shows us you take play seriously.
			</p>
			<div class="divider"></div>
			<h1 class="heading--sm heading text-center">
				Personal Information
			</h1>
			<hr />

			<form @submit.prevent="handleSubmit">
				<multiple-select
					label="dss"
					class="multiple-select"
					:list="departments"
					:value="departments"
				></multiple-select>
				<attachments></attachments>

				<!--<vue-recaptcha sitekey="Your key here">-->
				<!--<button>Click me</button>-->
				<!--</vue-recaptcha>-->

				<basic-button>Submit</basic-button>
				<input type="checkbox" id="checkbox" class="checkbox" />
				<label for="checkbox">I agree with terms</label>

				<div class="divider--sm"></div>

				<a
					href="https://www.bohemia.net/company/careers/terms"
					class="gdpr"
					>Read The Personal Data Processing Consent</a
				>
				<div class="divider--sm"></div>
			</form>
		</div>
	</div>
</template>

<script>
import BasicButton from "../BasicButton";
import { minLength, required } from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";

import MultipleSelect from "../common/MultipleSelect";
import departments from "../../assets/data/departments";
import Attachments from "./Attachments";

export default {
	components: {
		Attachments,
		MultipleSelect,
		BasicButton,
		VueRecaptcha
	},
	name: "UnsolicitedForm",
	data() {
		return {
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			picked: "true",
			attachments: [],
			portfolio: "",
			data: new FormData(),
			departments,
			activeDepartments: []
		};
	},
	validations: {
		firstName: {
			required,
			minLength: minLength(5)
		},
		lastName: {
			required,
			minLength: minLength(5)
		},
		email: {
			required,
			minLength: minLength(5)
		},
		phone: {
			required,
			minLength: minLength(5)
		}
	},
	methods: {
		handleSubmit() {}
	},
	computed: {
		active() {
			return [...this.activeDepartments.map(item => ({}))];
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/globals";

.application--wrapper__outer {
	background-color: $wild-sand;
}

hr {
	display: block;
	height: 1px;
	border: 0;
	border-top: 1px solid gray;
	margin: 1em 0;
	padding: 0;
}

.heading {
	margin: auto;
	max-width: 40%;
	margin-bottom: 1em;
	padding-top: 1em;
	font-size: 36px;

	@media (max-width: $tablet) {
		max-width: 100%;
	}
}

.paragraph {
	max-width: 60%;
	font-size: 16px;
	margin: auto;

	@media (max-width: $tablet) {
		max-width: 100%;
	}
}

.error {
	border-color: red;
	background: #fdd;
}

.error:focus {
	outline-color: #f99;
}

.valid {
	border-color: #5a5;
	background: #efe;
}

.valid:focus {
	outline-color: #8e8;
}

.attachment--text {
	color: gray;
	font-size: 14px;
}

.attach-button {
	background-color: black; /* Green */
	border: none;
	color: white;
	padding: 15px 32px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	font-size: 16px;
}

.gdpr {
	font-family: $font-paragraphs;
	text-decoration: underline;
	color: gray;
}

.divider--sm {
	padding-bottom: 2em;
}

.multiple-select {
	button {
		border-radius: 20px !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/applicationPageComponents/UnsolicitedForm.vue